module.exports = {
      id: "camera-usage",
      viewBox: "0 0 66 53",
      url: "img/" + "sprite.svg#camera-usage",
      toString: function () {
        return this.url;
      }
    }